<template>
  <div class="access-token-loader">
    <b-loading :is-full-page="true" :active="true" />
    <div class="loader-message">
      {{$t('loading')}}
    </div>
  </div>
</template>

<script>
import { Cytomine } from 'cytomine-client';
import { mapGetters } from 'vuex';

export default {
  name: 'access-with-token-loader',
  computed: {
    ...mapGetters({
      currentUser: 'currentUser/user',
      project: 'currentProject/project'
    })
  },
  async created() {
    const { token, username, redirect } = this.$route.query;
    if (!token || !username || !redirect) {
      this.$router.replace('/');
      return;
    }
    try {
      // Prevent App.vue from double-handling token login
      sessionStorage.setItem('guest-login-in-progress', '1');
      // Login with token
      let { shortTermToken } = await Cytomine.instance.loginWithToken(username, token);
      this.$store.commit('currentUser/setShortTermToken', shortTermToken);
      await this.$store.dispatch('currentUser/fetchUser');
      // Optionally, wait for project context if project id is in redirect
      const projectIdMatch = redirect.match(/project\/(\d+)/);
      if (projectIdMatch) {
        await this.$store.dispatch('currentProject/loadProject', projectIdMatch[1]);
      }
      // Wait until user is authenticated in store
      let tries = 0;
      while (!this.currentUser && tries < 10) {
        await new Promise(r => setTimeout(r, 200));
        tries++;
        await this.$store.dispatch('currentUser/fetchUser');
      }
      sessionStorage.removeItem('guest-login-in-progress');
      this.$router.replace(redirect);
    }
    catch (e) {
      sessionStorage.removeItem('guest-login-in-progress');
      this.$notify({ type: 'error', text: this.$t('invalid-token') });
      this.$router.replace('/');
    }
  }
};
</script>

<style scoped>
.access-token-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loader-message {
  margin-top: 2rem;
  font-size: 1.2rem;
  color: #333;
}
</style>
